export default "__VITE_ASSET__CXvsKka3__"